/**
 * Format a number as currency in euros
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.round(amount));
}

/**
 * Format a number as currency in euros with up to 2 decimal places for primes
 */
export function formatCurrencyPrecise(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
}

/**
 * Get the plural form of a profession name
 */
export function getProfessionPlural(professionId: string): string {
  switch (professionId) {
    case 'infirmier':
      return 'les infirmiers';
    case 'medecin':
      return 'les médecins';
    case 'kinesitherapeute':
      return 'les kinésithérapeutes';
    default:
      return 'les professionnels de santé';
  }
}